export default "__VITE_ASSET__2t4r6NXR__"